<template>
  <h1 class="head">
    IVD 全流程
  </h1>
  <p class="head-label mb-6">
    伴随诊断能解决药物研发风险高、治疗应答率低的问题。精准的伴随诊断结果能为临床选择合适的靶向药物提供有力的依据，筛选靶向药物最佳用药人群，实现精准化医疗。
  </p>

  <div class="mb-[30px]">
    <div class="mb-4">
      <img class="w-full"
        src="@/assets/homes/service/full-process-1.png">
    </div>
    <div class="text-base text-center text-[#0D0223]">IVD 全流程</div>
  </div>

  <div>
    <div class="mb-4">
      <img class="w-full"
        src="@/assets/homes/service/full-process-2.png">
    </div>
    <div class="text-base text-center text-[#0D0223]">IVD 全流程</div>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>